// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"14":"route.subcategories","84":"route.categories","103":"route.settings","945":"route.leadership"}[chunkId] || chunkId) + "." + {"14":"789e7190","84":"63d0ca75","103":"770700bc","181":"9561eda8","501":"fe012d35","563":"bbab91cf","945":"df20a798"}[chunkId] + ".chunk.js";
};